import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProducts = async (params = {}) => {
  const { data } = await axios.get(`${API}/products`, { params });
  return data;
};

export const fetchProduct = async (id) => {
  const { data } = await axios.get(`${API}/products/${id}`);
  return data;
};

export const sendInquiry = async (payload) => {
  const { data } = await axios.post(`${API}/inquiry`, payload);
  return data;
};

const authHeader = () => {
  const t = localStorage.getItem("hg_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (username, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { username, password });
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const createProduct = async (product) => {
  const { data } = await axios.post(`${API}/products`, product, { headers: authHeader() });
  return data;
};

export const updateProduct = async (id, product) => {
  const { data } = await axios.put(`${API}/products/${id}`, product, { headers: authHeader() });
  return data;
};

export const deleteProduct = async (id) => {
  const { data } = await axios.delete(`${API}/products/${id}`, { headers: authHeader() });
  return data;
};

export const reorderProducts = async (ids) => {
  const { data } = await axios.put(`${API}/products/reorder`, { ids }, { headers: authHeader() });
  return data;
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/admin/upload`, fd, { headers: { ...authHeader() } });
  return `${API}/files/${data.path}`;
};

const customerHeader = () => {
  const t = localStorage.getItem("hg_customer_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const createCheckout = async (items, originUrl, extra = {}) => {
  const { data } = await axios.post(`${API}/payments/checkout`, { items, origin_url: originUrl, ...extra }, { headers: customerHeader(), withCredentials: true });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};

export const getPaymentsConfig = async () => {
  const { data } = await axios.get(`${API}/payments/config`);
  return data;
};

export const createPayPalCheckout = async (items, originUrl, extra = {}) => {
  const { data } = await axios.post(`${API}/paypal/checkout`, { items, origin_url: originUrl, ...extra }, { headers: customerHeader(), withCredentials: true });
  return data;
};

export const capturePayPal = async (orderId) => {
  const { data } = await axios.post(`${API}/paypal/capture`, { order_id: orderId });
  return data;
};

export const fetchOrders = async () => {
  const { data } = await axios.get(`${API}/admin/orders`, { headers: authHeader() });
  return data;
};

export const fetchNextOrderNumber = async () => {
  const { data } = await axios.get(`${API}/admin/next-order-number`, { headers: authHeader() });
  return data;
};

export const getSettings = async () => {
  const { data } = await axios.get(`${API}/admin/settings`, { headers: authHeader() });
  return data;
};

export const updateSettings = async (payload) => {
  const { data } = await axios.put(`${API}/admin/settings`, payload, { headers: authHeader() });
  return data;
};

// ---------- Customer accounts ----------
export const customerRegister = async (payload) => {
  const { data } = await axios.post(`${API}/customer/register`, payload, { withCredentials: true });
  return data;
};
export const customerLogin = async (payload) => {
  const { data } = await axios.post(`${API}/customer/login`, payload, { withCredentials: true });
  return data;
};
export const customerGoogleSession = async (sessionId) => {
  const { data } = await axios.post(`${API}/customer/auth/session`, { session_id: sessionId }, { withCredentials: true });
  return data;
};
export const customerMe = async () => {
  const { data } = await axios.get(`${API}/customer/me`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const customerLogout = async () => {
  const { data } = await axios.post(`${API}/customer/logout`, {}, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const getWishlist = async () => {
  const { data } = await axios.get(`${API}/customer/wishlist`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const addWishlistItem = async (pid) => {
  const { data } = await axios.post(`${API}/customer/wishlist/${pid}`, {}, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const removeWishlistItem = async (pid) => {
  const { data } = await axios.delete(`${API}/customer/wishlist/${pid}`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const mergeWishlist = async (ids) => {
  const { data } = await axios.post(`${API}/customer/wishlist/merge`, { ids }, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const getMyOrders = async () => {
  const { data } = await axios.get(`${API}/customer/orders`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const exportMyData = async () => {
  const { data } = await axios.get(`${API}/customer/data-export`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const deleteMyAccount = async () => {
  const { data } = await axios.delete(`${API}/customer/account`, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const updateProfile = async (payload) => {
  const { data } = await axios.put(`${API}/customer/profile`, payload, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const updateAddress = async (payload) => {
  const { data } = await axios.put(`${API}/customer/address`, payload, { headers: customerHeader(), withCredentials: true });
  return data;
};
export const changePassword = async (payload) => {
  const { data } = await axios.put(`${API}/customer/password`, payload, { headers: customerHeader(), withCredentials: true });
  return data;
};
